export const getTransformedValue = ({
  value,
  truncate,
  preserveNegative,
}: any) => {
  let formattedValue = value ? value : 0;
  if (truncate) {
    formattedValue = parseInt(formattedValue, 10);
  }
  if (!preserveNegative) {
    formattedValue = Math.abs(formattedValue);
  }
  return formattedValue;
};
